/**
 * Created by mauget on 3/7/16.
 */

// PageInstanceFactory.js

import $ from 'jquery';
import BaseVisualControlFactory from 'BaseVisualControlFactory.js';
import constants        from 'Constants.js';
import sequenceService  from 'SequenceService.js';
import listService      from 'ListService.js';
import PageInstanceView from 'form/PageInstanceView.js';
import PageModel        from 'PageModel.js';
import pageSyncService  from 'PageSyncService.js';
import util                 from 'util/Util.js';

//=============================================================================
// Creates one page instance, given a factoryService parameter key.
//
// -Lou Mauget, March 7, 2016
//=============================================================================
class PageInstanceFactory extends BaseVisualControlFactory {
    pageInstanceView;

    createView( factoryKey, mode='', pos, altId, loading=false  ) { 
        
        //if (!listService.pageCount || mode==='addPage') {
        if (mode === 'addPage') {
            const attributes = this.createChildAttributes( factoryKey, pos ) ;

            if (altId) {
                if (listService.isValidId(altId)) {
                    attributes.id = altId;
                } else {
                    attributes.altId = altId;
                    attributes.id = listService.cleanId(altId);
                }
            } else {
                attributes.id = sequenceService.nextDomId();
            }

            attributes.pageNumber = listService.pageCount + 1;
            attributes.pageTitle  = `Page ${ attributes.pageNumber }`; // Defeault page title
            attributes.name       = `Page ${ attributes.pageNumber }`; // Defeault page name
            attributes.timestamp  = new Date().getTime();              // For creation-time ordering of thumbnails
            attributes.seq = sequenceService.nextNum(); 
 
            attributes.backgroundColor = '~pageBgColor';
            attributes.backgroundImageAssetId = '~pageBgImage';
            attributes.backgroundImageStyle = "center";
            //attributes.sharedSettingsTitle = 'Page Shared Settings';
            //attributes.tabSettingsTitle = 'Page Settings';
            attributes.displayMode = '';
            attributes.border = '1,solid';
            //attributes.behaviorCount = 0;
            //attributes.objectCount = 0; 

            listService.noPages = false;
            this.pageInstanceView =  new PageInstanceView( { model: new PageModel( attributes ),
                el: $(constants.FORM_ID), pos: undefined, factoryKey: factoryKey, id:  attributes.id } );

            listService.addPage(this.pageInstanceView.model.get('id'), this.pageInstanceView, {silent: loading} );
            listService.currentPageId = this.pageInstanceView.model.get('id'); 
        } else { 
            if (listService.pageList.size > 0) {
                this.pageInstanceView = listService.getPage(listService.currentPageId); 
            }
        }
 
        //------ Logging stuff -- not part of logic >>
        // console.log(`currentPageId`, listService.currentPageId);
        // console.log(`pageList`, listService.pageList.toJS());
        // listService.objectList
        //     .filter( v => v.model.get('pageId' === listService.currentPageId) )
        //     .map( v => console.log(`control`, v));
        //------ << Logging stuff -- not part of logic

        // This displays the page
        if (!loading && this.pageInstanceView) {
            pageSyncService.selectThumbNail(true);
        } 

        return this.pageInstanceView;
    }

    remove() { 
        this.pageInstanceView.remove();
        super.remove();
    }
}

const pageInstanceFactory = new PageInstanceFactory();
export default pageInstanceFactory;
